<mat-card>
  <mat-card-header>
    <mat-card-title class="mat-card-title-custom">
      {{ (mode == 'update' ? "title.update_config_link_report_contract_template" : "title.add_config_link_report_contract_template") | translate }}
    </mat-card-title>
  </mat-card-header>

  <form
    #f="ngForm"
    [formGroup]="addForm"
    (ngSubmit)="btnAction()"
    class="pb-3"
  >
    <mat-card-content class="mb-3 mat-card-content-contract-sm">
      <mat-accordion>
        <mat-expansion-panel expanded="true" class="mt-3">
          <mat-expansion-panel-header>
            <mat-panel-title class="mat-panel-title">
              {{ "labor_utilization_report.general_information" | translate }}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="row">
            <div class="col-4">
              <!-- Mẫu hợp đồng lao động -->
              <mat-form-field class="w-100">
                <mat-select
                  required
                  id="status"
                  name="status"
                  formControlName="documentTypeEnterpriseId"
                  [placeholder]="'labor_utilization_report.labor_contract_template' | translate"
                >
                  <mat-option>
                    <ngx-mat-select-search
                      [formControl]="documentTypeEnterpriseIdCtrl"
                      [noEntriesFoundLabel]="
                        'autocomplete.suggestion' | translate
                      "
                      [placeholderLabel]="'search_form.search' | translate"
                      [searching]="loadingSearch"
                    >
                    </ngx-mat-select-search>
                  </mat-option>
                  <mat-option
                    *ngFor="let contractTemplate of listContractTemplateFilter | async"
                    [value]="contractTemplate?.id"
                    [matTooltip]="contractTemplate?.code  + ' - ' + contractTemplate?.name"
                  >
                  {{ contractTemplate?.code }} - {{ contractTemplate?.name }}
                  </mat-option>
                </mat-select>
                <button
                  mat-button
                  *ngIf="addForm?.controls?.documentTypeEnterpriseId?.value"
                  type="button"
                  matSuffix
                  mat-icon-button
                  aria-label="Clear"
                  (click)="clearData('documentTypeEnterpriseId')"
                >
                  <mat-icon>close</mat-icon>
                </button>
                <mat-error *ngIf="!addForm.controls.documentTypeEnterpriseId.value">
                  {{ "labor_utilization_report.labor_contract_template_required" | translate }}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-3" *ngIf="addForm?.controls?.documentTypeEnterpriseId?.value">
              <!-- Loại hợp đồng -->
              <mat-form-field class="w-100 mat-form-field-disabled">
                <input
                  matInput
                  type="text"
                  [placeholder]="'labor_utilization_report.contract_type' | translate"
                  maxlength="200"
                  autocomplete="off"
                  formControlName="documentType"
                  disabled
                  [readonly]="true"
                />
              </mat-form-field>
            </div>
            <div class="col-3" *ngIf="addForm?.controls?.documentTypeEnterpriseId?.value">
              <!-- Loại hợp đồng lao động -->
              <mat-form-field class="w-100 mat-form-field-disabled">
                <input
                  matInput
                  type="text"
                  [placeholder]="'labor_utilization_report.type_of_labor_contract' | translate"
                  maxlength="200"
                  autocomplete="off"
                  formControlName="documentTypeLD"
                  disabled
                  [readonly]="true"
                />
              </mat-form-field>
            </div>
            <div class="col-2 d-flex flex-column justify-content-start" *ngIf="addForm?.controls?.documentTypeEnterpriseId?.value">
              <div>
                {{ "labor_utilization_report.status" | translate }}
              </div>
              <div class="wrap-status mt-1">
                <div *ngIf="addForm?.controls?.status?.value">
                  <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="4" cy="4" r="4" fill="#12B76A"/>
                  </svg>
                  <span class="ml-1" style="color: #027A48">{{"labor_utilization_report.active" | translate}}</span>
                </div>
                <div *ngIf="!addForm?.controls?.status?.value">
                  <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="4" cy="4" r="4" fill="#6B7280"/>
                  </svg>
                  <span class="ml-1" style="color: #3B3F46">{{"system_document_template.cbx_document_status.cbx_document_status_inactive" | translate}}</span>
                </div>
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>

      <mat-accordion [multi]="true">
        <mat-expansion-panel expanded="true" [hideToggle]="true" class="mt-3 criteria-panel">
          <mat-expansion-panel-header (click)="$event.stopPropagation()">
            <mat-panel-title class="mat-panel-title">
              {{ "labor_utilization_report.reporting_criteria_configuration" | translate }}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="criteria-table-wrapper">
            <mat-table
              [dataSource]="listDataSource"
              [trackBy]="trackByCode"
              class="criteria-table">
              <ng-container matColumnDef="groupHeader">
                <mat-cell *matCellDef="let element" class="group-header-cell">
                  <button mat-icon-button type="button" class="toggle-button"
                    (click)="toggleGroup(element)">
                    <ng-container *ngIf="!element.expanded"> 
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M6 8H10M8 6V10M2 3.33333C2 2.97971 2.14048 2.64057 2.39052 2.39052C2.64057 2.14048 2.97971 2 3.33333 2H12.6667C13.0203 2 13.3594 2.14048 13.6095 2.39052C13.8595 2.64057 14 2.97971 14 3.33333V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V3.33333Z" stroke="#6F767E" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                  </ng-container>
                  <ng-container *ngIf="element.expanded"> 
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M5.33333 8H10.6667M5.2 14H10.8C11.9201 14 12.4802 14 12.908 13.782C13.2843 13.5903 13.5903 13.2843 13.782 12.908C14 12.4802 14 11.9201 14 10.8V5.2C14 4.0799 14 3.51984 13.782 3.09202C13.5903 2.71569 13.2843 2.40973 12.908 2.21799C12.4802 2 11.9201 2 10.8 2H5.2C4.0799 2 3.51984 2 3.09202 2.21799C2.71569 2.40973 2.40973 2.71569 2.21799 3.09202C2 3.51984 2 4.0799 2 5.2V10.8C2 11.9201 2 12.4802 2.21799 12.908C2.40973 13.2843 2.71569 13.5903 3.09202 13.782C3.51984 14 4.0799 14 5.2 14Z" stroke="#6B7280" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                  </ng-container>
                  </button>
                  <strong>{{ element.name }}</strong>
                </mat-cell>
              </ng-container>
              <!-- STT -->
              <ng-container matColumnDef="stt">
                <mat-header-cell
                  *matHeaderCellDef
                  class="mat-cell-non-boder-right-bottom"
                  >{{ "headertable.stt" | translate }}
                </mat-header-cell>
                <mat-cell
                  *matCellDef="let element; let i = index"
                  class="mat-cell-non-boder-right-bottom"
                >
                  <button *ngIf="element.rowType === 'subheader'"
                    mat-icon-button type="button" class="toggle-button"
                    (click)="toggleGroup(element)">
                    <mat-icon>{{ element.expanded ? 'keyboard_arrow_down' : 'keyboard_arrow_right' }}</mat-icon>
                  </button>
                  <span *ngIf="!element.level || element.level <= 1">
                    {{ element.displayOrder }}
                  </span>
                </mat-cell>
              </ng-container>
              <!-- Tên tiêu chí -->
              <ng-container matColumnDef="nameCriteria">
                <mat-header-cell
                  *matHeaderCellDef
                  class="mat-cell-non-boder-right-bottom"
                >
                  {{ "labor_utilization_report.criterion_name" | translate }}
                </mat-header-cell>
                <mat-cell
                  *matCellDef="let element; let i = index"
                  [matTooltip]="element.name"
                  [class.subheader-name]="element.rowType === 'subheader'"
                  class="mat-cell-non-boder-right-bottom cell"
                >
                  <span class="fix-width fw-100 nameDoc">
                    <span *ngIf="element.level > 1" class="child-display-order">
                      {{ element.displayOrder }}
                    </span>
                    {{ element.name }}
                  </span>
                </mat-cell>
              </ng-container>
              <!-- Trường thông tin của mẫu -->
              <ng-container matColumnDef="infoTemplate">
                <mat-header-cell
                  *matHeaderCellDef
                  class="text-center mat-cell-non-boder-right-bottom"
                >
                  {{ "labor_utilization_report.template_information_fields" | translate }}
                </mat-header-cell>
                <mat-cell
                  *matCellDef="let element; let i = index"
                  class="mat-cell-non-boder-right-bottom d-flex justify-content-center"
                >
                  <div
                    *ngIf="element.rowType === 'criterion'"
                    class="w-100 control-with-error"
                  >
                    <nz-select
                      class="merge-field-select"
                      nzShowSearch
                      nzAllowClear
                      [nzFilterOption]="filterMergeFieldOption"
                      [nzPlaceHolder]="'labor_utilization_report.select' | translate"
                      [formControl]="element.controlField"
                    >
                      <nz-option
                        *ngFor="let data of optionsMap.get(element.id)"
                        [nzValue]="data.mergeField"
                        [nzLabel]="data.mergeField"
                      >
                      </nz-option>
                    </nz-select>
                    <!-- <div
                      *ngIf="element.isRequired && element.controlField?.touched && element.controlField?.errors?.required"
                      class="control-error"
                    >
                      {{ "add_document_moha.please_select_information_field" | translate }}
                    </div> -->
                  </div>
                </mat-cell>
              </ng-container>

              <mat-header-row
                *matHeaderRowDef="displayedColumns"
              ></mat-header-row>
              <mat-row
                *matRowDef="let row; columns: headerColumns; when: isHeaderRow"
                [class.row-hidden]="!isRowVisible(row)"
                class="group-header-row">
              </mat-row>
              <mat-row
                *matRowDef="let row; columns: displayedColumns; when: isCriterionRow"
                [class.subheader-row]="row.rowType === 'subheader'"
                [class.row-hidden]="!isRowVisible(row)"
                class="criterion-row">
              </mat-row>
            </mat-table>
          </div>
        </mat-expansion-panel>
        <mat-card-actions class="text-center">
          <button
            mat-stroked-button
            color="primary"
            class="mr-3"
            type="button"
            (click)="cancel(true)"
          >
            <mat-icon class="mr-0">
              cancel
            </mat-icon>
            {{ "button.cancel" | translate }}
          </button>
          
          <button mat-raised-button color="primary" type="submit" id="save" [disabled]="!disabledSave">
            <mat-icon class="mr-0">
              save
            </mat-icon>
            <span *ngIf="mode === 'update'">
              {{ "button.update" | translate }}
            </span>
            <span *ngIf="mode === 'create'">
              {{ "button.add" | translate }}
            </span>
          </button>
        </mat-card-actions>
      </mat-accordion>

    </mat-card-content>
  </form>
</mat-card>
